import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/hoantp'
      className='link footer__link'
    >
      Created By bố Xoài
    </a>
  </footer>
)

export default Footer
